<div data-test="jddPs_OY" class="tabs-bg-content block block_shadow">
  <div data-test="8F4WFZWf" class="modules-container">
    <ng-content></ng-content>
  </div>
</div>
